import React from "react";
import { useQuery } from "@tanstack/react-query";
import { sharedApi } from "@/lib/api";
import { useAuth } from "@/lib/auth";

/**
 * Red unread-count pip for the Header chat button. Polls the existing
 * GET /classifieds/chats endpoint (each conversation carries an
 * `unread` integer) and sums it — no new backend needed. Renders
 * nothing when logged out or fully read.
 */
export default function ChatUnreadBadge() {
  const { user } = useAuth();

  const q = useQuery({
    queryKey: ["chats-unread", user?.id],
    queryFn: async () => {
      const { data } = await sharedApi.get("/classifieds/chats");
      const list = data?.conversations || data?.chats || [];
      return list.reduce((sum, c) => sum + (Number(c.unread) || 0), 0);
    },
    enabled: !!user,
    refetchInterval: 60_000,
    retry: 0,
  });

  const unread = q.data || 0;
  if (!user || unread <= 0) return null;

  return (
    <span
      data-testid="header-chat-unread-count"
      className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-red-500 text-white text-[10px] font-bold grid place-items-center"
    >
      {unread > 99 ? "99+" : unread}
    </span>
  );
}
